import Api from "./index";

export default class PDFPreviewApi extends Api {

    constructor (apiURL) {
        super(apiURL);
    }

    async getPdfPreview(token) {
        return await this.apiConnector({ data: {mode: 'getPreview', token: token}, ignoreDefaultParams: true });
    }

    async markAsDownloaded(token) {
        return await this.apiConnector({ data: {mode: 'markAsDownloaded', token: token}, ignoreDefaultParams: true });
    }

    isWithCredentials() {
        return false;
    }
}